export interface AppMenuItem {
  label?: string;
  icon?: string;
  routerLink?: string[];
  items?: AppMenuItem[];
  separator?: boolean;
  badge?: string;
  badgeSeverity?: 'success' | 'info' | 'warning' | 'danger';
  /** API module key — if set, item is hidden unless the user's modules array includes this key or '*' */
  moduleKey?: string;
  /** If set, item is only visible for users whose userType matches one of these values */
  allowedUserTypes?: string[];
}

export const MENU: AppMenuItem[] = [
  // TODO: unhide when dashboard is ready
  // {
  //   label: 'Home',
  //   items: [
  //     { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'] },
  //   ]
  // },
  {
    label: 'Patient',
    items: [
      { label: 'Face Sheet',    icon: 'pi pi-fw pi-id-card', routerLink: ['/facesheet'],      moduleKey: 'facesheet' },
      { label: 'Authorization', icon: 'pi pi-fw pi-shield',  routerLink: ['/authorization'],  moduleKey: 'authorization' },
    ]
  },
  {
    label: 'Financial',
    items: [
      { label: 'Write Off', icon: 'pi pi-fw pi-dollar', routerLink: ['/writeoff'], moduleKey: 'writeoff' },
    ]
  },
  {
    label: 'Administration',
    items: [
      { label: 'Providers',       icon: 'pi pi-fw pi-briefcase', routerLink: ['/providers'], moduleKey: 'providers' },
      { label: 'User Management', icon: 'pi pi-fw pi-users',     routerLink: ['/users'],     moduleKey: 'users' },
    ]
  },
];
